import { ArrowUpRight } from "lucide-react";
import { Container } from "./SiteChrome";
import { InquiryForm } from "./InquiryForm";
import { useCmsBatch } from "../hooks/useCmsBatch";

const contactInfoDefault = [
  { title: "Address", body: "15001 Calvert Street\nVan Nuys, CA 91411", link: "https://maps.google.com/?q=15001+Calvert+Street+Van+Nuys+CA+91411" },
  { title: "Phone", body: "+1 (747) 688-9668", link: "tel:+17476889668" },
  { title: "Email", body: "info@formulasoccer.com", link: "mailto:info@formulasoccer.com" },
];
const contactHoursDefault = [
  { title: "Mon — Fri", body: "9:00 AM — 9:00 PM" },
  { title: "Saturday", body: "8:00 AM — 8:00 PM" },
  { title: "Sunday", body: "9:00 AM — 6:00 PM" },
];

export function ContactSection({ eyebrowNumber = "07" }) {
  const { content } = useCmsBatch(["contact-info", "contact-hours"]);
  const infoSection = content["contact-info"] || {};
  const hoursSection = content["contact-hours"] || {};
  const info = infoSection.items?.length ? infoSection.items : contactInfoDefault;
  const hours = hoursSection.items?.length ? hoursSection.items : contactHoursDefault;

  return (
    <section className="section contact" id="contact">
      <Container className="grid-12">
        <div className="contact__details">
          <p className="eyebrow lime">
            <span>{eyebrowNumber}</span>
            Contact us
          </p>
          <h2>
            {infoSection.title || "Let's get in touch"}
          </h2>
          <dl>
            {info.map((item) => (
              <div key={item.title}>
                <dt>{item.title}</dt>
                <dd>
                  {item.link ? (
                    <a href={item.link} target={item.link.startsWith("http") ? "_blank" : undefined} rel={item.link.startsWith("http") ? "noreferrer" : undefined}>
                      {item.body.split("\n").map((line, i) => (
                        <span key={i}>{i > 0 && <br />}{line}</span>
                      ))}
                    </a>
                  ) : (
                    item.body
                  )}
                </dd>
              </div>
            ))}
          </dl>
          <div className="hours">
            {hours.map((slot) => (
              <p key={slot.title}>
                <span>{slot.title}</span>
                <b>{slot.body}</b>
              </p>
            ))}
          </div>
          <InquiryForm
            source="tour_request"
            submitLabel="Book a tour"
            successMessage="Thanks! Our team will reach out to schedule your tour shortly."
            messagePlaceholder="Tell us about your player (optional)"
          />
        </div>
        <div className="map-panel">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d894.9929680338436!2d-118.46048743036621!3d34.18157250776351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c29736a02e7b87%3A0x7ebbb485c5b72fde!2sFORMULA%20SOCCER%20CENTER!5e1!3m2!1sen!2s!4v1789604885039!5m2!1sen!2s"
            title="Formula Soccer Center location"
            width="100%"
            height="100%"
            style={{ border: "1px solid var(--dark-rule)", flex: 1, minHeight: 300 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
          />
          <a
            href="https://maps.google.com/?q=15001+Calvert+Street+Van+Nuys+CA+91411"
            target="_blank"
            rel="noreferrer"
          >
            Open in Google Maps <ArrowUpRight size={16} strokeWidth={1.5} aria-hidden="true" />
          </a>
        </div>
      </Container>
    </section>
  );
}
